import { Controller } from "@hotwired/stimulus"

// Hands off from one dialog to another (modal replacement): paired with
// `dialog#close` on a button inside the first dialog, it clicks the second
// dialog's (possibly hidden) activator so that dialog's own controller manages
// its open state.
export default class extends Controller {
  static values = { selector: String }

  open() {
    document.querySelector(this.selectorValue)?.click()
  }
}
